function fetchConfig(type = "json") {
  var contentType = "application/" + type;

  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: contentType,
    },
  };
}
if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
        this.hideErrors = this.dataset.hideErrors === 'true';
      }
      onSubmitHandlerGiftBox(quanlity, key) {
        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        document.getElementById("gift-box-quantity").value = quanlity;
        const formData = new FormData(document.getElementById("form-gift-box"));
        formData.append(`[properties][_parentKey]`, key);
        config.body = formData;
        return fetch(`${routes.cart_add_url}`, config).then((response) =>
          response.json()
        );
      }
      onSubmitHandlerGiftCard(quanlity, key) {
        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        document.getElementById("gift-card-quantity").value = quanlity;
        const formData = new FormData(
          document.getElementById("form-gift-card")
        );
        formData.append(`[properties][_parentKey]`, key);
        config.body = formData;
        return fetch(`${routes.cart_add_url}`, config).then((response) =>
          response.json()
        );
      }
      async onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        if (this.querySelector('.loading-overlay__spinner')) {
          this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        let key = new Date().getTime().toString();
        formData.append(`[properties][_itemKey]`, key);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
         var inputBuyGift = document.getElementById("choose-to-buy");
        const pack = document.querySelector(".form-pack")
        if(pack){
          formData.append(`[properties][isNotChangeQty]`, true);
        }
        config.body = formData;

        if (inputBuyGift && inputBuyGift.checked) {
          //config.body = this.getAddonVariant(formData);
          const rectGift = inputBuyGift.getBoundingClientRect();
          const isVisible =
            rectGift.bottom > 0 && rectGift.top < window.innerHeight;
          let quantity = document.querySelector(
            "product-form.product-form form input[name='quantity']"
          ).value;

          const qtyBox = document.querySelector("input[name='quantity-box']")
          if(qtyBox){
            quantity = qtyBox.value || 1;
            key = undefined;
          }

          if (isVisible) {
            await this.onSubmitHandlerGiftBox(quantity, key);
          }
        }

        var inputBuyGiftCard = document.getElementById("choose-to-buy-card");
        if (inputBuyGiftCard && inputBuyGiftCard.checked) {
          //config.body = this.getAddonVariant(formData);
          const rectGift = inputBuyGiftCard.getBoundingClientRect();
          const isVisible =
            rectGift.bottom > 0 && rectGift.top < window.innerHeight;
          const quantity = document.querySelector(
            "product-form.product-form form input[name='quantity']"
          ).value;
          if (isVisible) {
            await this.onSubmitHandlerGiftCard(quantity, key);
          }
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { 
                source: 'product-form', 
                productVariantId: formData.get('id') 
              });

            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                {
                  once: true
                }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            if (this.querySelector('.loading-overlay__spinner') != null) {
              this.querySelector('.loading-overlay__spinner').classList.add('hidden');
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
